
const serverURL = 'https://serverhasteg.deltabyte.com.br'


export default serverURL
